import { Box, Card, styled, Typography, darken  } from '@mui/material';
import Flecha from '../assets/icons/flecha-icon.jsx';
import { Link } from 'react-router-dom';

interface CardProps {
  icon: JSX.Element;
  title: string;
  description: string;
  button: string;
  link: string;
}

const CardWrapper = styled(Card)(({ theme }) => ({
  textAlign: 'center',
  maxWidth: 180,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2.5rem .5rem 1rem .5rem',

  [theme.breakpoints.down('lg')]: {
    marginBottom: '1rem',
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  fontSize: '.9rem',
  letterSpacing: 0,
  fontWeight: 'bold',
  textAlign: 'center',
  marginTop: '.3rem',
  marginBottom: '.3rem',
  color: theme.palette.grey[500],
}));

const TypographyLink = styled(Typography)(({ theme }) => ({
  marginRight: '.3rem',
  fontSize: '.75rem',
  letterSpacing: 0,
  fontWeight: '100',
  color: 'rgb(255, 255, 255)',
}));

const LinkItem = styled(Link)<{ component: 'Link' }>(({ theme }) => ({
  textDecoration: 'none',
  color: '#ffffff',
  backgroundColor: theme.palette.primary.main,
  padding: '0.3rem 0.6rem',
  borderRadius: '0.3rem',
  borderBottom: '1px solid',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  marginTop: 'auto',
  transition: 'background-color 0.3s ease',
  '&:hover': {
    backgroundColor: darken(theme.palette.primary.main, 0.2),
  },
}));

export default function LoginCard(props: CardProps) {
  const { icon, title, description, button, link } = props;

  return (
    <CardWrapper variant="outlined">
      <Box>
        {icon}
        <Title>{title}</Title>
        <Typography
          variant="body1"
          sx={{ fontSize: '.7rem', lineHeight: '0.9rem' }}
        >
          {description}
        </Typography>
      </Box>
      <br style={{ marginTop: '2rem' }}></br>
      <LinkItem component="Link" to={link}>
        <TypographyLink>{button}</TypographyLink>
        <Flecha color="#ffffff" />
      </LinkItem>
    </CardWrapper>
  );
}
